import React from "react";
import { Link } from "react-router-dom";
import { openCookieSettings } from "./CookieBanner";
import { useHp } from "../lib/limited";
import { useFamilies } from "../lib/families";

export default function Footer() {
  const hp = useHp();
  const [fams] = useFamilies();
  const ig = (hp.seo_instagram || "").trim() || "https://www.instagram.com/crunchysweet.fr/";
  const tt = (hp.seo_tiktok || "").trim() || "https://www.tiktok.com/@crunchysweet.fr";
  return (
    <footer className="cs-ft">
      <style>{CS_FOOTER_CSS}</style>
      <div className="cs-ft-wrap">
        <div className="cs-ft-top">
          <div className="cs-ft-brand">
            <img loading="lazy" decoding="async" className="cs-ft-logo" src="/static/home/logo-line-cream.webp" width="480" height="55" alt="Crunchy Sweet" />
            <img loading="lazy" decoding="async" className="cs-ft-masc" src="/static/home/masc-duo-cream.png" width="300" height="157" alt="" />
            <span>Pâtisserie artisanale · Palaiseau (91) · contact@crunchysweet.fr</span>
            <span className="cs-ft-socials">
              <a data-testid="footer-instagram" href={ig} target="_blank" rel="me noopener noreferrer" aria-label="Instagram @crunchysweet.fr">
                <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4.2" /><circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" /></svg>
              </a>
              <a data-testid="footer-tiktok" href={tt} target="_blank" rel="me noopener noreferrer" aria-label="TikTok @crunchysweet.fr">
                <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M16.6 2h-3.4v13.4a2.9 2.9 0 1 1-2.9-2.9c.3 0 .6 0 .9.1V9.1a6.4 6.4 0 1 0 5.4 6.3V8.6a8 8 0 0 0 4.4 1.4V6.6c-2.4 0-4.4-2-4.4-4.6z" /></svg>
              </a>
            </span>
          </div>
          <div className="cs-ft-cols">
            <div><b>La carte</b>
              <Link to="/cookies">Cookies</Link>
              <Link to="/brownies">Brownies</Link>
              <Link to="/cupcookies">Cupcookies</Link>
              {fams.map((f) => <Link key={f.slug} to={`/${f.slug}`} data-testid={`footer-fam-${f.slug}`}>{f.name}</Link>)}
              <Link to="/composer-ma-box">Composer ma box</Link>
            </div>
            <div><b>Infos</b>
              <Link to="/comment-commander">Comment commander</Link>
              <Link to="/a-propos">À propos</Link>
              <Link to="/evenements">Événements</Link>
              <Link to="/offrir">Offrir Crunchy Sweet</Link>
              <Link to="/suivi">Suivre ma commande</Link>
              {hp.blog_on && <Link to="/blog" data-testid="footer-blog">Le blog</Link>}
            </div>
            <div><b>Près de chez toi</b>
              {hp.lp_palaiseau_on !== false && <Link to="/cookies-palaiseau" data-testid="footer-lp-palaiseau">{(hp.lp_palaiseau_h1 || "").trim() || "Cookies à Palaiseau"}</Link>}
              {hp.lp_entreprises_on !== false && <Link to="/cookies-entreprises-essonne" data-testid="footer-lp-entreprises">{(hp.lp_entreprises_h1 || "").trim() || "Cookies pour entreprises en Essonne"}</Link>}
              <Link to="/livraison-retrait">Livraison &amp; retrait</Link>
            </div>
          </div>
        </div>
        <div className="cs-ft-bot">
          <span>© {new Date().getFullYear()} Crunchy Sweet · Fait maison avec amour</span>
          <div>
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/cgv">CGV</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <Link to="/allergenes">Allergènes</Link>
            <Link to="/livraison-retrait">Livraison &amp; retrait</Link>
            <Link to="/mediation">Médiation</Link>
            <button type="button" data-testid="manage-cookies-btn" onClick={openCookieSettings}>Gérer les cookies</button>
          </div>
        </div>
      </div>
    </footer>
  );
}

const CS_FOOTER_CSS = `
.cs-ft{--orange-deep:#A8410F;--paper:#FFF8F1;--peach:#FBEDE2;--display:'Bricolage Grotesque',ui-sans-serif,system-ui,sans-serif;background:var(--orange-deep);color:var(--peach);font-family:var(--display);font-size:16px}
.cs-ft-wrap{max-width:1320px;margin:0 auto;padding:64px 20px 30px;display:flex;flex-direction:column;gap:46px}
.cs-ft a{color:inherit;text-decoration:none}
.cs-ft a:hover{color:#fff;text-decoration:underline}
.cs-ft img{display:block}
.cs-ft-top{display:flex;flex-wrap:wrap;gap:40px;justify-content:space-between}
.cs-ft-brand{display:flex;flex-direction:column;gap:14px;max-width:440px}
.cs-ft-logo{width:clamp(180px,18vw,240px);height:auto}
.cs-ft-masc{width:clamp(110px,10vw,140px);height:auto}
.cs-ft-socials{display:flex;gap:10px}
.cs-ft-socials a{width:46px;height:46px;border-radius:999px;border:1.5px solid rgba(255,248,241,.6);display:grid;place-items:center;transition:background .2s,color .2s}
.cs-ft-socials a:hover{background:var(--paper);color:var(--orange-deep);text-decoration:none}
.cs-ft-cols{display:flex;gap:52px;flex-wrap:wrap}
.cs-ft-cols div{display:flex;flex-direction:column;gap:9px}
.cs-ft-cols b{color:var(--paper);font-size:17px}
.cs-ft-bot{display:flex;flex-wrap:wrap;gap:14px 20px;justify-content:space-between;font-size:14px;border-top:1px solid rgba(255,248,241,.3);padding-top:20px}
.cs-ft-bot div{display:flex;gap:16px;flex-wrap:wrap;align-items:center}
.cs-ft-bot button{background:transparent;border:0;color:inherit;cursor:pointer;font:inherit;text-decoration:underline}
.cs-ft-bot button:hover{color:#fff}
@media (max-width:640px){
.cs-ft{font-size:15px}
.cs-ft-wrap{padding:40px 20px 24px;gap:28px}
.cs-ft-top{gap:24px}
.cs-ft-brand{gap:10px}
.cs-ft-logo{width:150px}
.cs-ft-masc{width:84px}
.cs-ft-socials a{width:44px;height:44px}
.cs-ft-cols{gap:22px 24px;flex-wrap:wrap}
.cs-ft-cols div{flex:1 1 0;gap:7px}
.cs-ft-cols b{font-size:15px}
}
`;
